<template>
    <div class="calendar">
        <div class="calendar__date-picker">
            <v-date-picker :select-attribute="selectAttribute" :drag-attribute="dragAttribute" @update:modelValue="updateValue" v-model="date" :attributes="attrs" :min-date='new Date()' :disabled-dates="disabledDates" :locale="{masks: { weekdays: 'WW'}}" :model-config="modelConfig" ref="calendar" is-range />
        </div>
    </div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    export default {
        name: "Calendar",
        components: {
            Tooltip,
        },
        props: {
            modelValue: {},
            disabledDates: null,
            measureDate: {
                default: function(){
                    return false
                }
            },
        },
        watch: {

        },
        data: function () {
            return {
                //date: null,
                modelConfig:{
                    type: 'string',
                    mask: 'YYYY.MM.DD',
                },
                dragAttr: {
                   highlight: {
                     // here, class style isn't working
                     start: {
                       fillMode: "outline",
                       class: "day-cell-highlight",
                     },
                     // style attribute is working
                     base: {
                       fillMode: "light",
                       style: {
                         backgroundColor: '#000',
                         opacity: 0.08,
                       },
                     },
                     end: {
                       fillMode: "outline",
                       style: {
                         borderColor: '#000',
                       },
                     },
                   },
                 },
                attrs: [
                    // {
                    //   key: 'today',
                    //   dot: true,
                    //   dates: new Date(),
                    // },
                    {
                        highlight:{
                            class: 'weekend',
                            contentClass: 'disabled'
                        },
                        dates: { weekdays: [1, 7] }
                    }
                 ],
                 selectAttribute: {
                    highlight: {
                        base: {
                            contentStyle: {
                                color: '#fff', // light blue
                            }
                        },
                        start: {
                            fillMode: 'solid',
                            class: "selected",
                            contentStyle: {
                                color: '#fff',
                            },
                        },
                        end: {
                            fillMode: 'solid',
                            class: "selected",
                            contentStyle: {
                                color: '#fff',
                            },
                        },
                    }
                 },
                 dragAttribute: {
                     highlight: {
                         base: {
                             contentStyle: {
                                 color: '#fff', // light blue
                             }
                         },
                         start: {
                             contentStyle: {
                                 color: '#ffc700',
                             },
                         },
                         end: {
                             contentStyle: {
                                 color: '#ffc700',
                             },
                         },

                     }
                 },
                 //minutes: '00',
                 //hours: '11',
                 weekdays: ['воскресенье','понедельник','вторник','среда', 'четверг','пятница', 'суббота'],
                 months: ['янв','фев','мар', 'апр','мая', 'июн','июл','авг','сен','окт','ноя','дек'],
                 cdHidden: false,
                 hint: '',
            }
        },
        computed: {
            date: {
                get() {
                    //setTimeout(()=>{
                        //this.$refs.calendar.focusDate(this.modelValue.date);
                        //console.log(this.modelValue.date);
                    //}, 5);
                    return this.modelValue;
                },
                set(value) {}
            },
        },
        mounted: function () {
        },
        emits: ['update:modelValue', 'calendarshow', 'input'],
        methods: {
            updateValue(value){
                let val = value;
                this.$emit('update:modelValue', val);
                document.getElementsByTagName('body')[0].click();
            },
            slideLeft(){
                this.$refs.calendar.move(-1);
            },
            slideRight(){
                this.$refs.calendar.move(1);
            },
            formatDate(date) {
              let dd = date.getDate();
              if (dd < 10) dd = '0' + dd;

              let mm = date.getMonth() + 1;
              if (mm < 10) mm = '0' + mm;

              let yyyy = date.getFullYear();

              return yyyy + '.' + mm + '.' + dd;
            }
        },
    }
</script>

<style scoped>
</style>
